import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { colors } from "../configs";
import { useSelector } from "react-redux";
import { goToTop } from "../Utility/function";
import { stringDateTimeReceipt, stringFullDate, stringYMDHMS3, timeDifferenceDecimal } from "../Utility/dateTime";
import TablePagination from '@mui/material/TablePagination';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';
import { Modal_Loading } from "../modal";
import { Download, TimeControlCheckIn } from "../components";

const { darkGray, white } = colors;
function ReportCheckInScreen() {
  const { t } = useTranslation();
  const { shop } = useSelector((state)=> state.shop);
  const { humanResource  } = shop;
  const { modal_Deposit, selectedCheckIns, startDate, endDate } = useSelector(state=>state.checkIn)

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [masterDisplay, setMasterDisplay] = useState([])
  const [display, setDisplay] = useState([]);

  useEffect(()=>{
        let arr = []
        for(const item of selectedCheckIns){
            let findStaff = humanResource.find(a=>a.id===item.profileId)
            if(findStaff){
                const { id, email, name, tel } = findStaff
                arr.push({...item, id, email, name, tel })
            }
        }
        setMasterDisplay(arr)
  },[selectedCheckIns,humanResource])



    const handleChangePage = (event, newPage) => {
        setPage(newPage); // start form 0
        goToTop()
    };
  
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        goToTop()
    };

    useEffect(()=>{
        let arr = masterDisplay

      let fData = arr.map((item,index)=>{return({...item,no:index+1})}).filter((item,index)=>{return(index >=(page*rowsPerPage) && index <= ((page+1)*rowsPerPage)-1)})
        setDisplay(fData)
    },[page,rowsPerPage,masterDisplay]);


const exportToXlsx = async () => {
    const imageCells = [];
    const data = await Promise.all(
      masterDisplay.map(async (item, index) => {
        const { clockIn, clockOut, clockInImage, clockOutImage, email, name, tel } = item;
  
  
        return {
            No: index + 1,
            ชื่อ: name,
            อีเมล: email,
            เบอร์โทร: tel,
            วันที่: stringFullDate(clockIn,t),
            เวลาเข้างาน: stringDateTimeReceipt(clockIn),
            เวลาออกงาน: stringDateTimeReceipt(clockOut),
            รวมชั่วโมงการทำงาน: timeDifferenceDecimal(clockOut, clockIn),
        };
      })
    );
  
    // Create Excel worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);
  
    // Add images
    worksheet["!images"] = imageCells;
  
    // Create workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'รายงานเวลาทำงาน');
  
    // Generate filename dynamically
    const fileName = `รายงานเวลาทำงาน ${stringYMDHMS3(startDate)}-${stringYMDHMS3(endDate)}.xlsx`;
  
    // Write and trigger download without file-saver
    XLSX.writeFile(workbook, fileName);
  };



  return (
    <div  >

<Modal_Loading show={modal_Deposit} />
        <h1>รายงานเวลาทำงาน</h1>
        <TimeControlCheckIn/>

      <div style={styles.container2} >
        <h4>&emsp;{t('shift.result',{ length:display.length })}</h4> 
      <Download exportToXlsx={exportToXlsx} />
        
      </div>
      {/* <Button onClick={test} >test</Button> */}

      <br/>
      <Table striped bordered hover responsive  variant="light" style={styles.container3}  >
                  
        <thead  >
          <tr>
            <th style={styles.text2} >No.</th>
            <th style={styles.text2} >ชื่อ</th>
            <th style={styles.text2} >อีเมล</th>
            <th style={styles.text2} >เบอร์โทร</th>
            <th style={styles.text2} >วันที่</th>
            <th style={styles.text2} >เวลาเข้างาน</th>
            <th style={styles.text2} >เวลาออกงาน</th>
            <th style={styles.text2} >รวมชั่วโมงการทำงาน</th>
            <th style={styles.text2} >รูปเข้างาน</th>
            <th style={styles.text2} >รูปออกงาน</th>
          </tr>
        </thead>
        <tbody  >
          {display.map((item, index) => {
            const { clockIn, clockOut, clockInImage, clockOutImage, email, name, tel } = item;
            return <tr  key={index} >
                      <td style={styles.text2}>{index+1}.</td>
                      <td style={styles.text2}>{name}</td>
                      <td style={styles.text2}>{email}</td>
                      <td style={styles.text2}>{tel}</td>
                      <td style={styles.text2}>{stringFullDate(clockIn,t)}</td>
                      <td style={styles.text2}>{stringDateTimeReceipt(clockIn)}</td>
                      <td style={styles.text2}>{stringDateTimeReceipt(clockOut)}</td>
                      <td style={styles.text2}>{timeDifferenceDecimal(clockOut,clockIn)}</td>
                      
                      {clockInImage
                        ?<td style={styles.text2}>
                            <img style={{width:'80px'}} src={clockInImage} />
                        </td>
                        :<td style={styles.text2}></td>
                        }
                          {clockOutImage
                        ?<td style={styles.text2}>
                            <img style={{width:'80px'}} src={clockOutImage} />
                        </td>
                        :<td style={styles.text2}></td>
                        }
                      

                    </tr>
          })}
        </tbody>
      </Table>
      <TablePagination
            component="div"
            count={selectedCheckIns.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    </div>
  );
};

const styles = {
    text : {
      width:'5%',
      textAlign:'center',
      minWidth:'100px'
    },
    text2 : {
      width:'8%',
      textAlign:'center',
      minWidth:'180px'
    },
    container : {
      backgroundColor:darkGray,textDecoration:'none',color:white,padding:10,borderRadius:20,paddingLeft:30,paddingRight:30
    },
    container2 : {
      display:'flex',justifyContent:'space-between',marginRight:'1rem'
    },
    container3 : {
      marginLeft:'1rem'
    }
  }

export default ReportCheckInScreen;
